var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveComparison(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.091,
    height: 20,
    viewBox: "0 0 19.091 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-md-list",
    "data-name": "Icon ionic-md-list",
    transform: "translate(0 20) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1870",
    "data-name": "Group 1870",
    transform: "translate(0 5.455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8374",
    "data-name": "Path 8374",
    d: "M0,2.727H14.545V0H0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8375",
    "data-name": "Path 8375",
    d: "M0,2.727H18.182V0H0Z",
    transform: "translate(0 5.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8376",
    "data-name": "Path 8376",
    d: "M0,2.727H20V0H0Z",
    transform: "translate(0 10.909)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8377",
    "data-name": "Path 8377",
    d: "M0,2.727H10V0H0Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveComparison);
export default __webpack_public_path__ + "static/media/remove_comparison.8fd38457c882b348c7fbdcf262d62ac7.svg";
export { ForwardRef as ReactComponent };